// Returns true if passed an object
function isObject(obj) {
    return obj === Object(obj);
}

// Return true if passed an empty object
function isEmptyObject(obj) {
    return isObject(obj) && Object.keys(obj).length === 0;
}

// If object x has key y which is an array of length z, return that array
function getObjectKeyOfLength(obj, key, length) {
    if (!isObject(obj)) {
        return null;
    }
    return obj[key] && obj[key].length === length ? obj[key] : null;
}

export {
    isObject,
    isEmptyObject,
    getObjectKeyOfLength
};
